import { Box, Button, ButtonGroup, Divider, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import ToolSelect from './ToolSelect'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { SvgIconProps } from '../Svgs'

/** Group 1 */
const SvgIcon11: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='19'
    viewBox='0 0 15 19'
    color='none'
  >
    <path
      d='M14.0006 10.5875L0.582892 0.0799862C0.293894 -0.156988 -0.0790185 0.168384 0.00132168 0.587417L3.66152 17.7118C3.76133 18.2324 4.48989 18.2003 4.61447 17.6881C6.07634 11.6768 10.8409 11.6014 14.0006 11.5875C14.4128 11.5857 14.3449 10.8698 14.0006 10.5875Z'
      color={color}
    />
  </svg>
)

const SvgIcon12: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='21'
    viewBox='0 0 21 21'
    color='none'
  >
    <rect
      x='3.85938'
      y='3.86035'
      width='16.64'
      height='16.64'
      stroke={color}
      strokeDasharray='1.68 1.68'
    />
    <line y1='3.7002' x2='7.56' y2='3.7002' stroke={color} />
    <line
      x1='3.69922'
      y1='7.55957'
      x2='3.69922'
      y2='-0.000429608'
      stroke={color}
    />
  </svg>
)

const SvgIcon13: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='7'
    viewBox='0 0 25 7'
    color='none'
  >
    <line x1='2.47461' y1='3.5' x2='21.4746' y2='3.5' stroke={color} />
    <line x1='2.97461' y1='2.54977e-08' x2='2.97461' y2='7' stroke={color} />
    <line x1='5.30277' y1='1.37894' x2='0.353025' y2='6.32869' stroke={color} />
    <line x1='23.7774' y1='1.37894' x2='18.8276' y2='6.32869' stroke={color} />
    <line x1='21.9746' y1='2.54977e-08' x2='21.9746' y2='7' stroke={color} />
  </svg>
)

const SvgIcon14: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='19'
    height='20'
    viewBox='0 0 19 20'
    color='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.99485 14H5.59712L8.73775 5.27273H10.2591L13.3997 14H12.002L9.53462 6.85795H9.46644L6.99485 14ZM7.22923 10.5824H11.7633V11.6903H7.22923V10.5824Z'
      color={color}
    />
    <rect
      x='0.578947'
      y='0.578947'
      width='17.8421'
      height='18.8421'
      rx='3.42105'
      stroke={color}
      strokeWidth='1.15789'
    />
  </svg>
)

/** Group 2 */

const SvgIcon21: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='27'
    viewBox='0 0 22 27'
    color='none'
  >
    <path
      d='M12 1L6.91703 9.80396L16.3492 15.2496L21.4322 6.44567'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M9.83601 21.016L5.18186 18.3289L6.91797 9.80469L16.3502 15.2504L9.83601 21.016Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M5.01022 24.0576C4.33776 23.6694 3.93376 23.0409 4.06071 22.5656L5.17578 18.3252L9.8963 21.0506L6.78153 24.1365C6.43593 24.4796 5.68711 24.4484 5.01465 24.0602L5.01022 24.0576Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
  </svg>
)

const SvgIcon22: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='30'
    viewBox='0 0 28 30'
    color='none'
  >
    <path
      d='M13 1L7.91703 9.80396L21.9016 17.878L26.9846 9.074'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M13.5943 24.0528L4.51864 23.9154L8.9375 16.2617L15.8037 20.2259L13.5943 24.0528Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M15.8218 20.2373L8.91576 16.2501L7.91797 9.80469L21.9026 17.8787L15.8218 20.2373Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
  </svg>
)

const SvgIcon23: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='20'
    viewBox='0 0 19 20'
    color='none'
  >
    <path
      d='M0.5 7.26059C0.5 5.25795 1.93622 3.54366 3.9079 3.19288L13.6447 1.4606C16.1763 1.01021 18.5 2.95695 18.5 5.52831V19.5H0.5V7.26059Z'
      stroke={color}
    />
  </svg>
)

/** Group 3 */

const SvgIcon31: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='21'
    viewBox='0 0 21 21'
    color='none'
  >
    <path d='M1 21C1 9.9543 9.9543 1 21 1' stroke={color} />
  </svg>
)

const SvgIcon32: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='21'
    viewBox='0 0 21 21'
    color='none'
  >
    <path
      d='M20.799 0.20101L15.2222 1.6953L19.3047 5.77779L20.799 0.20101ZM1.35355 20.3536L17.9706 3.73654L17.2635 3.02944L0.646447 19.6464L1.35355 20.3536Z'
      color={color}
    />
  </svg>
)

/** Group 4 */

const SvgIcon41: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='34'
    height='20'
    viewBox='0 0 34 20'
    color='none'
  >
    <rect
      x='0.578947'
      y='0.578947'
      width='17.8421'
      height='18.8421'
      rx='3.42105'
      stroke={color}
      strokeWidth='1.15789'
    />
    <path
      d='M34 10L28.2105 6.65745L28.2105 13.3426L34 10ZM18 10.5789L28.7895 10.5789L28.7895 9.42105L18 9.42105L18 10.5789Z'
      color={color}
    />
  </svg>
)

const SvgIcon42: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='25'
    viewBox='0 0 25 25'
    color='none'
  >
    <path
      d='M11.2133 2.11993C11.7958 1.14796 13.2042 1.14796 13.7867 2.11993L14.6149 3.50206C15.181 4.4468 16.2987 4.90977 17.3671 4.64204L18.93 4.25037C20.0291 3.97493 21.0251 4.97086 20.7496 6.07L20.358 7.63295C20.0902 8.70129 20.5532 9.81899 21.4979 10.3851L22.8801 11.2133C23.852 11.7958 23.852 13.2042 22.8801 13.7867L21.4979 14.6149C20.5532 15.181 20.0902 16.2987 20.358 17.3671L20.7496 18.93C21.0251 20.0291 20.0291 21.0251 18.93 20.7496L17.3671 20.358C16.2987 20.0902 15.181 20.5532 14.6149 21.4979L13.7867 22.8801C13.2042 23.852 11.7958 23.852 11.2133 22.8801L10.3851 21.4979C9.81899 20.5532 8.70129 20.0902 7.63295 20.358L6.07 20.7496C4.97086 21.0251 3.97493 20.0291 4.25037 18.93L4.64204 17.3671C4.90977 16.2987 4.4468 15.181 3.50206 14.6149L2.11993 13.7867C1.14796 13.2042 1.14796 11.7958 2.11993 11.2133L3.50206 10.3851C4.4468 9.81899 4.90977 8.70129 4.64204 7.63295L4.25037 6.07C3.97493 4.97086 4.97086 3.97493 6.07 4.25037L7.63295 4.64204C8.70129 4.90977 9.81899 4.4468 10.3851 3.50206L11.2133 2.11993Z'
      stroke={color}
    />
  </svg>
)

const SvgIcon43: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='16'
    viewBox='0 0 21 16'
    color='none'
  >
    <rect
      x='0.5'
      y='0.5'
      width='20'
      height='15'
      stroke={color}
      strokeDasharray='3 1.5'
    />
    <line x1='2' y1='4.72266' x2='6' y2='4.72266' stroke={color} />
    <line x1='3.7207' y1='7' x2='3.7207' y2='3' stroke={color} />
    <line x1='15' y1='4.16699' x2='18' y2='4.16699' stroke={color} />
    <line x1='16.1641' y1='6' x2='16.1641' y2='3' stroke={color} />
    <path d='M2 15L8.5 6L14.5 14L17.5 10.5L20.5 14' stroke={color} />
  </svg>
)

const SvgIcon51: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='20'
    viewBox='0 0 19 20'
    color='none'
  >
    <path
      d='M0.529974 7.01077L1.2604 3.86221C1.75449 1.73241 3.86707 0.393915 6.00386 0.856841L14.4159 2.67928C16.5801 3.14813 17.9515 5.28602 17.4754 7.4486L16.3561 12.533'
      stroke={color}
    />
    <rect
      x='0.5'
      y='3.63574'
      width='15.8701'
      height='15.8701'
      rx='3.5'
      stroke={color}
    />
  </svg>
)

const SvgIcon52: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    color='none'
  >
    <mask id='path-1-inside-1_2943_6246' color={color}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.0343 19.4739C15.2765 19.3179 19.4783 15.0192 19.4783 9.73913C19.4783 4.36036 15.1179 0 9.73913 0C4.45946 0 0.161028 4.20116 0.00442005 9.44287H0V9.73913V19.4771H9.58892C9.6389 19.4779 9.68897 19.4783 9.73913 19.4783C9.78929 19.4783 9.83936 19.4779 9.88934 19.4771H10.0343V19.4739Z'
      />
    </mask>
    <path
      d='M10.0343 19.4739L10.0045 18.4743L9.03426 18.5032V19.4739H10.0343ZM0.00442005 9.44287V10.4429H0.974989L1.00397 9.47274L0.00442005 9.44287ZM0 9.44287V8.44287H-1V9.44287H0ZM0 19.4771H-1V20.4771H0V19.4771ZM9.58892 19.4771L9.60403 18.4772L9.59648 18.4771H9.58892V19.4771ZM9.88934 19.4771V18.4771H9.88179L9.87423 18.4772L9.88934 19.4771ZM10.0343 19.4771V20.4771H11.0343V19.4771H10.0343ZM18.4783 9.73913C18.4783 14.4769 14.7079 18.3343 10.0045 18.4743L10.064 20.4734C15.8451 20.3014 20.4783 15.5615 20.4783 9.73913H18.4783ZM9.73913 1C14.5656 1 18.4783 4.91264 18.4783 9.73913H20.4783C20.4783 3.80807 15.6702 -1 9.73913 -1V1ZM1.00397 9.47274C1.14448 4.76981 5.00175 1 9.73913 1V-1C3.91718 -1 -0.822428 3.6325 -0.995134 9.41301L1.00397 9.47274ZM0 10.4429H0.00442005V8.44287H0V10.4429ZM1 9.73913V9.44287H-1V9.73913H1ZM1 19.4771V9.73913H-1V19.4771H1ZM9.58892 18.4771H0V20.4771H9.58892V18.4771ZM9.73913 18.4783C9.69402 18.4783 9.64898 18.4779 9.60403 18.4772L9.57381 20.477C9.62882 20.4778 9.68393 20.4783 9.73913 20.4783V18.4783ZM9.87423 18.4772C9.82928 18.4779 9.78425 18.4783 9.73913 18.4783V20.4783C9.79434 20.4783 9.84944 20.4778 9.90445 20.477L9.87423 18.4772ZM10.0343 18.4771H9.88934V20.4771H10.0343V18.4771ZM9.03426 19.4739V19.4771H11.0343V19.4739H9.03426Z'
      color={color}
      mask='url(#path-1-inside-1_2943_6246)'
    />
  </svg>
)

export const toolsGroup1 = {
  name: 'Group 1',
  tools: [
    {
      name: 'Tool 11',
      icon: SvgIcon11,
    },
    {
      name: 'Tool 12',
      icon: SvgIcon12,
    },
    {
      name: 'Tool 13',
      icon: SvgIcon13,
    },
    {
      name: 'Tool 14',
      icon: SvgIcon14,
    },
  ],
}

export const toolsGroup2 = {
  name: 'Group 2',
  tools: [
    {
      name: 'Tool 21',
      icon: SvgIcon21,
    },
    {
      name: 'Tool 22',
      icon: SvgIcon22,
    },
    {
      name: 'Tool 23',
      icon: SvgIcon23,
    },
  ],
}

export const toolsGroup3 = {
  name: 'Group 3',
  tools: [
    {
      name: 'Tool 31',
      icon: SvgIcon31,
    },
    {
      name: 'Tool 32',
      icon: SvgIcon32,
    },
  ],
}

export const toolsGroup4 = {
  name: 'Group 4',
  tools: [
    {
      name: 'Tool 41',
      icon: SvgIcon41,
    },
    {
      name: 'Tool 42',
      icon: SvgIcon42,
    },
    {
      name: 'Tool 43',
      icon: SvgIcon43,
    },
  ],
}

export const toolsGroup5 = {
  name: 'Group 5',
  tools: [
    {
      name: 'Tool 51',
      icon: SvgIcon51,
    },
    {
      name: 'Tool 52',
      icon: SvgIcon52,
    },
  ],
}

interface ToolsProps {
  disabled?: boolean
}

const Tools: React.FC<ToolsProps> = ({ disabled }) => {
  const [isToolPanelActive, setIsToolPanelActive] = useState<boolean>(false)
  const [selectedToolGroup, setSelectedToolGroup] = useState<string>(
    toolsGroup1.name,
  )
  const activeTool = useSelector((state: RootState) => state.permit.activeTool)

  const isToolGroupSelected = (toolGroupName: string) =>
    selectedToolGroup === toolGroupName

  const handleToolPanelClick = () => {
    setIsToolPanelActive(!isToolPanelActive)
  }

  const handleToolsGroupClick = (groupName: string) => {
    setSelectedToolGroup(groupName)
  }

  useEffect(() => {
    const group = [
      toolsGroup1,
      toolsGroup2,
      toolsGroup3,
      toolsGroup4,
      toolsGroup5,
    ].find(
      (group) =>
        group.tools.findIndex((tool) => tool.name === activeTool) !== -1,
    )
    handleToolsGroupClick(group ? group.name : '')
  }, [activeTool])

  return (
    <Box sx={{ display: 'flex' }}>
      <ButtonGroup
        disableRipple
        size='small'
        variant='text'
        aria-label='Basic button group'
        sx={{
          width: '100%',
          height: '34px',
          borderRadius: '6px',
          background: '#4C4C4C',
          '& .MuiButtonGroup-grouped': {
            borderRadius: '4px',
            border: 'none',
            minWidth: '53px',
          },
          '& .MuiButtonGroup-grouped:hover': {
            borderRadius: '4px',
            background: '#B5B5B5',
            border: 'none',
          },
        }}
      >
        {[toolsGroup1, toolsGroup2, toolsGroup3, toolsGroup4, toolsGroup5].map(
          (group, index) => (
            <React.Fragment key={group.name}>
              <ToolSelect
                items={group}
                onSelect={handleToolsGroupClick}
                sx={{
                  background: isToolGroupSelected(group.name)
                    ? '#202020'
                    : 'transparent',
                  color: isToolGroupSelected(group.name) ? '#3F69FF' : '#fff',
                }}
                disabled={disabled}
              />
              {index < 4 && (
                <Divider
                  orientation='vertical'
                  variant='middle'
                  flexItem
                  sx={{ backgroundColor: 'rgba(119, 119, 119, 0.60)' }}
                />
              )}
            </React.Fragment>
          ),
        )}
        <Button onClick={handleToolPanelClick}>
          <Typography
            sx={{
              color: '#fff',
              fontSize: '14px',
              lineHeight: 'normal',
              textTransform: 'capitalize',
              fontWeight: '500',
              px: '7px',
            }}
          >
            Tool Panel
          </Typography>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 18 18'
            color='none'
          >
            <circle
              cx='9'
              cy='9'
              r='9'
              color={isToolPanelActive ? '#3F69FF' : '#353535'}
            />
            <path
              d='M6.00586 12.2832L8.87028 9.41878L6.00586 6.55436'
              stroke='white'
              strokeMiterlimit='10'
            />
            <path
              d='M10.1367 12.2832L13.0011 9.41878L10.1367 6.55436'
              stroke='white'
              strokeMiterlimit='10'
            />
          </svg>
        </Button>
      </ButtonGroup>
      {isToolPanelActive ? (
        <Box columnGap='6px' sx={{ display: 'flex', ml: '6px' }}>
          <Divider
            orientation='vertical'
            flexItem
            sx={{ backgroundColor: 'rgba(119, 119, 119, 0.60)' }}
          />
          <ButtonGroup
            disabled={disabled}
            disableRipple
            size='small'
            variant='text'
            aria-label='Basic button group'
            sx={{
              width: '100%',
              borderRadius: '6px',
              background: '#4C4C4C',
              '& .MuiButtonGroup-grouped': {
                borderRadius: '4px',
                border: 'none',
                minWidth: '53px',
                height: '100%',
              },
              '& .MuiButtonGroup-grouped:hover': {
                borderRadius: '4px',
                background: '#202020',
                border: 'none',
              },
            }}
          >
            <Button>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='24'
                viewBox='0 0 32 24'
                color='none'
              >
                <path
                  d='M31.1367 13L28.0687 9.93193L25.0006 13'
                  stroke='white'
                  strokeMiterlimit='10'
                />
                <path
                  d='M0.999691 9.35C0.997713 7.70008 1.48516 6.08665 2.40037 4.71383C3.31558 3.34101 4.61741 2.27049 6.14117 1.63772C7.66493 1.00495 9.34214 0.838367 10.9606 1.15904C12.5791 1.47971 14.066 2.27323 15.2334 3.4392C16.4008 4.60517 17.1961 6.0912 17.5187 7.70927C17.8413 9.32734 17.6767 11.0048 17.0458 12.5293C16.4149 14.0538 15.3459 15.3569 13.9742 16.2738C12.6025 17.1906 10.9896 17.68 9.33969 17.68C7.12952 17.68 5.00972 16.8027 3.44595 15.2408C1.88219 13.6789 1.00234 11.5602 0.999691 9.35Z'
                  stroke='white'
                />
                <path d='M11.6797 1L11.6797 24' stroke='white' />
                <path d='M6.67969 1L6.67969 24' stroke='white' />
              </svg>
            </Button>
            <Divider
              orientation='vertical'
              variant='middle'
              flexItem
              sx={{ backgroundColor: 'rgba(119, 119, 119, 0.60)' }}
            />
            <Button>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='24'
                viewBox='0 0 32 24'
                color='none'
              >
                <path
                  d='M31.1367 13L28.0687 9.93193L25.0006 13'
                  stroke='white'
                  strokeMiterlimit='10'
                />
                <path
                  d='M0.999691 9.35C0.997713 7.70008 1.48516 6.08665 2.40037 4.71383C3.31558 3.34101 4.61741 2.27049 6.14117 1.63772C7.66493 1.00495 9.34214 0.838367 10.9606 1.15904C12.5791 1.47971 14.066 2.27323 15.2334 3.4392C16.4008 4.60517 17.1961 6.0912 17.5187 7.70927C17.8413 9.32734 17.6767 11.0048 17.0458 12.5293C16.4149 14.0538 15.3459 15.3569 13.9742 16.2738C12.6025 17.1906 10.9896 17.68 9.33969 17.68C7.12952 17.68 5.00972 16.8027 3.44595 15.2408C1.88219 13.6789 1.00234 11.5602 0.999691 9.35Z'
                  stroke='white'
                />
                <path d='M11.6797 1L11.6797 24' stroke='white' />
                <path d='M6.67969 1L6.67969 24' stroke='white' />
              </svg>
            </Button>
            <Divider
              orientation='vertical'
              variant='middle'
              flexItem
              sx={{ backgroundColor: 'rgba(119, 119, 119, 0.60)' }}
            />
            <Button>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='24'
                viewBox='0 0 32 24'
                color='none'
              >
                <path
                  d='M31.1367 13L28.0687 9.93193L25.0006 13'
                  stroke='white'
                  strokeMiterlimit='10'
                />
                <path
                  d='M0.999691 9.35C0.997713 7.70008 1.48516 6.08665 2.40037 4.71383C3.31558 3.34101 4.61741 2.27049 6.14117 1.63772C7.66493 1.00495 9.34214 0.838367 10.9606 1.15904C12.5791 1.47971 14.066 2.27323 15.2334 3.4392C16.4008 4.60517 17.1961 6.0912 17.5187 7.70927C17.8413 9.32734 17.6767 11.0048 17.0458 12.5293C16.4149 14.0538 15.3459 15.3569 13.9742 16.2738C12.6025 17.1906 10.9896 17.68 9.33969 17.68C7.12952 17.68 5.00972 16.8027 3.44595 15.2408C1.88219 13.6789 1.00234 11.5602 0.999691 9.35Z'
                  stroke='white'
                />
                <path d='M11.6797 1L11.6797 24' stroke='white' />
                <path d='M6.67969 1L6.67969 24' stroke='white' />
              </svg>
            </Button>
            <Divider
              orientation='vertical'
              variant='middle'
              flexItem
              sx={{ backgroundColor: 'rgba(119, 119, 119, 0.60)' }}
            />
            <Button>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='24'
                viewBox='0 0 32 24'
                color='none'
              >
                <path
                  d='M31.1367 13L28.0687 9.93193L25.0006 13'
                  stroke='white'
                  strokeMiterlimit='10'
                />
                <path
                  d='M0.999691 9.35C0.997713 7.70008 1.48516 6.08665 2.40037 4.71383C3.31558 3.34101 4.61741 2.27049 6.14117 1.63772C7.66493 1.00495 9.34214 0.838367 10.9606 1.15904C12.5791 1.47971 14.066 2.27323 15.2334 3.4392C16.4008 4.60517 17.1961 6.0912 17.5187 7.70927C17.8413 9.32734 17.6767 11.0048 17.0458 12.5293C16.4149 14.0538 15.3459 15.3569 13.9742 16.2738C12.6025 17.1906 10.9896 17.68 9.33969 17.68C7.12952 17.68 5.00972 16.8027 3.44595 15.2408C1.88219 13.6789 1.00234 11.5602 0.999691 9.35Z'
                  stroke='white'
                />
                <path d='M11.6797 1L11.6797 24' stroke='white' />
                <path d='M6.67969 1L6.67969 24' stroke='white' />
              </svg>
            </Button>
            <Divider
              orientation='vertical'
              variant='middle'
              flexItem
              sx={{ backgroundColor: 'rgba(119, 119, 119, 0.60)' }}
            />
            <Button>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='24'
                viewBox='0 0 32 24'
                color='none'
              >
                <path
                  d='M31.1367 13L28.0687 9.93193L25.0006 13'
                  stroke='white'
                  strokeMiterlimit='10'
                />
                <path
                  d='M0.999691 9.35C0.997713 7.70008 1.48516 6.08665 2.40037 4.71383C3.31558 3.34101 4.61741 2.27049 6.14117 1.63772C7.66493 1.00495 9.34214 0.838367 10.9606 1.15904C12.5791 1.47971 14.066 2.27323 15.2334 3.4392C16.4008 4.60517 17.1961 6.0912 17.5187 7.70927C17.8413 9.32734 17.6767 11.0048 17.0458 12.5293C16.4149 14.0538 15.3459 15.3569 13.9742 16.2738C12.6025 17.1906 10.9896 17.68 9.33969 17.68C7.12952 17.68 5.00972 16.8027 3.44595 15.2408C1.88219 13.6789 1.00234 11.5602 0.999691 9.35Z'
                  stroke='white'
                />
                <path d='M11.6797 1L11.6797 24' stroke='white' />
                <path d='M6.67969 1L6.67969 24' stroke='white' />
              </svg>
            </Button>
          </ButtonGroup>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default Tools
